import { render, staticRenderFns } from "./ArchivesInformationShow.vue?vue&type=template&id=5bfa7afc&"
import script from "./ArchivesInformationShow.vue?vue&type=script&lang=js&"
export * from "./ArchivesInformationShow.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesInformationShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports